"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var table_1 = require("antd/lib/table");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var PartnerBalancesList = /** @class */ (function (_super) {
    __extends(PartnerBalancesList, _super);
    function PartnerBalancesList(props) {
        return _super.call(this, props) || this;
    }
    PartnerBalancesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
            _this.props.state.setExtBreadCrumbPath(["Детали выплат партнера"]);
        });
    };
    PartnerBalancesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PartnerBalancesList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Партнер',
                dataIndex: this.props.data.dk_app_currency_id,
                key: this.props.data.dk_app_currency_id,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.rootRecord.login));
                },
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_title,
                key: this.props.data.dk_app_currency_title,
                width: 150
            }, {
                title: 'Баланс',
                dataIndex: this.props.data.dk_balance,
                key: this.props.data.dk_balance,
                width: 150
            }]);
    };
    PartnerBalancesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PartnerBalancesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(table_1.default, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] ")));
                }, scroll: { x: true } })));
    };
    return PartnerBalancesList;
}(React.Component));
exports.default = PartnerBalancesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/component/balances/PartnerBalancesList.tsx
// module id = 2441
// module chunks = 0